// extracted by mini-css-extract-plugin
module.exports = {"lotteryInfoContainer":"LotteryInfo_lotteryInfoContainer__ytoyx","lotteryInfoText":"LotteryInfo_lotteryInfoText__vdXpI"};